import styled from 'styled-components';
import { greyStroke } from 'styles/colors';

export const BoundingShape = styled.g`
    fill: white;
    stroke: ${greyStroke};
    stroke-width: 1px;
`;
